// Auto import modal components
/* eslint-disable */
import Vue, { PluginObject } from 'vue'
import { getKeys } from '~/lib/utils/utils'
import '~/assets/scss/_vue-js-modal.scss'

const importComponents = (context:__WebpackModuleApi.RequireContext) => {
  return context.keys().reduce((acc, key) => {
    const componentName = key.replace(/^.*[\\/]/, '').split('.')[0]
    acc[componentName] = context(key).default
    return acc
  }, {} as {[key: string]: Utils.Object})
}

const components = importComponents(require.context('~/components/common/modals/', false, /\.vue$/))

// Install the above defined components
const modals: PluginObject<Vue> = {
  install (Vue) {
    getKeys(components).forEach((componentName) => {
      if (typeof componentName !== 'string') { return }
      Vue.component(componentName, components[componentName])
    })
  }
}

Vue.use(modals)

// Vue js modal initialization
// plugins/vue-js-modal.js
import VModal from 'vue-js-modal'

Vue.use(VModal, {
  dynamicDefaults: {
    height: 'auto',
    adaptive: true,
    scrollable: true,
    clickToClose: false,
    classes: 'mb-80',
    styles: {
      width: '590px',
      shadowMod: '0px 0px 18px rgba(0, 0, 0, 0.05)',
      borderRadius: '5px'
    }
  }
})
